export default __webpack_public_path__ + "static/media/Wotune.8279fa1c.jpg";